import { useEffect, useState } from "react";
import { CommonService } from "../../../services/CommonService";
import { useAdvanceSearchContext } from "./AdvanceSearchContextTest";
import { DropDownMultiCheck } from "./DropDownMultiCheck";
import IconDelete from "../../../layout/others/icon-x.svg";

export default function ManagerInterest() {
  const { searchObject,setSearchObject, t } = useAdvanceSearchContext();
  const [interestTypes, setInterestTypes] = useState([]);

  useEffect(
    () =>
      CommonService.getInterestType().then((data) =>
        setInterestTypes(data)
      ),
    []
  );
  function setSelectedManagerInterest(list) { 

    setSearchObject({ ...searchObject, managerInterestId: list });
  }

  function clearManagers() {
    let _searchObject = { ...searchObject };
    _searchObject.managerInterestId = [];

    setSearchObject(_searchObject);
  }

  return (
    <>
    <div>
      <legend className="fontsize-legend">{t("Manager Interest")}</legend>
      {searchObject.managerInterestId.length !== 0 && (
        <button
          onClick={clearManagers}
          className="btn-clear-language-level position-clear-button"
        >
          <img src={IconDelete} alt="ico-ppl" height="12px" width="auto"/>
        </button>
      )}
        <DropDownMultiCheck
        dataList={interestTypes}
        selecteds={searchObject.managerInterestId}
        setSelecteds={setSelectedManagerInterest}
      />
    </div>
    </>
  );
}
